var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "history") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.800000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-details-with-copy-2",
    transform: "translate(-940.000000, -50.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy-2",
    transform: "translate(938.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,2.5 C11.0376667,2.5 13.5,4.96233333 13.5,8 C13.5,11.0376667 11.0376667,13.5 8,13.5 L7.96033333,13.4983333 C6.531,13.3846667 5.37066666,12.9033333 4.50033333,12.061 L4.5,13.1666667 L3.5,13.1666667 L3.5,10 L6.33333333,10 L6.33333333,11 L4.88266667,11 C5.60533334,11.8893333 6.64033334,12.3863333 8.01966667,12.5 L8.124,12.4983333 C10.552,12.4326667 12.5,10.4436667 12.5,8 C12.5,5.51466667 10.4853333,3.5 8,3.5 C5.51466667,3.5 3.5,5.51466667 3.5,8 L2.5,8 C2.5,4.96233333 4.96233333,2.5 8,2.5 Z M7.33333333,5 L8.33333333,5 L8.33333333,7.5 L10.8333333,7.5 L10.8333333,8.5 L7.33333333,8.5 L7.33333333,5 Z",
    id: "history"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.51b8d8c2.svg";
export { ForwardRef as ReactComponent };